import React, { useState } from "react";
import { useSecureContext } from "../../../hooks/secure-http-context";
import { RouteConfig } from "../../../routes/AuthRoutes";
import { UnauthenticatedError } from "../../../utils/errors/UnauthenticatedError";
import { AlertComponent } from "../../shared/AlertComponent";
import { InputComponent } from "../../shared/InputComponent";
import { LinkComponent } from "../../shared/LinkComponent";
import { NblocksButton } from "../../shared/NblocksButton";
import { useTranslation } from "react-i18next";
const RequireMfaComponent = ({
  didCommitMfaCode,
  setupMode
}) => {
  const {
    authService
  } = useSecureContext();
  const [mfaCode, setMfaCode] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const {
    t
  } = useTranslation();
  const submit = async event => {
    event.preventDefault();
    setIsLoading(true);
    let recoverCode = undefined;
    try {
      if (setupMode) {
        recoverCode = await authService.finishMfaUserSetup(mfaCode);
      } else {
        await authService.commitMfaCode(mfaCode);
      }
      didCommitMfaCode(recoverCode);
    } catch (error) {
      if (error instanceof UnauthenticatedError) {
        setErrorMsg(t("Wrong security code, please try again."));
      } else {
        setErrorMsg(t("There was an error when logging in. Try again, otherwise contact support."));
      }
      setMfaCode("");
    } finally {
      setIsLoading(false);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, errorMsg && /*#__PURE__*/React.createElement("div", {
    className: "max-w-sm w-full mb-6"
  }, /*#__PURE__*/React.createElement(AlertComponent, {
    type: "danger",
    title: t("An error occured"),
    messages: [errorMsg]
  })), /*#__PURE__*/React.createElement("form", {
    onSubmit: event => submit(event),
    className: "space-y-6 max-w-sm w-full"
  }, /*#__PURE__*/React.createElement(InputComponent, {
    type: "text",
    label: t("Secure code"),
    placeholder: t("Enter the secure code"),
    name: "username",
    onChange: event => setMfaCode(event.target.value),
    value: mfaCode
  }), !setupMode && /*#__PURE__*/React.createElement("div", {
    className: "flex justify-end"
  }, /*#__PURE__*/React.createElement(LinkComponent, {
    to: RouteConfig.mfa.recoverMfaScreen,
    type: "primary",
    className: "font-semibold",
    size: "sm"
  }, t("Use recover code?"))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(NblocksButton, {
    submit: true,
    disabled: !mfaCode,
    size: "md",
    isLoading: isLoading,
    type: "primary",
    fullWidth: true
  }, t("Verify")))), /*#__PURE__*/React.createElement("div", {
    className: "mt-8"
  }, /*#__PURE__*/React.createElement(LinkComponent, {
    to: RouteConfig.login.loginScreen,
    type: "secondary",
    size: "sm",
    className: "font-semibold"
  }, t("Back to login"))));
};
export { RequireMfaComponent };